module.exports = __webpack_public_path__ + "img/login-avatar.29b3cfa9.png";